import { render, staticRenderFns } from "./MdHighAlertAssessmentNotes.vue?vue&type=template&id=0e85877b&"
import script from "./MdHighAlertAssessmentNotes.vue?vue&type=script&lang=js&"
export * from "./MdHighAlertAssessmentNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports